import { render, staticRenderFns } from "./JbManPreventivaOsErp.vue?vue&type=template&id=745c1f68&"
import script from "./JbManPreventivaOsErp.vue?vue&type=script&lang=js&"
export * from "./JbManPreventivaOsErp.vue?vue&type=script&lang=js&"
import style0 from "./JbManPreventivaOsErp.vue?vue&type=style&index=0&id=745c1f68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports